"use client";

import { EditableAutocomplete } from "../forms/EditableValue";

export const TECHNOLOGY_CATEGORY_LABELS: Record<string, string> = {
  "ai-ambient-scribes": "Ambient Documentation",
  "clinical-documentation-integrity-cdi": "Clinical Documentation Integrity",
  "ai-contact-center": "Call Center AI",
  "denials-management": "Denial Management",
  "insurance-discovery": "Insurance Discovery",
  "autonomous-coding": "Autonomous Coding",
  "patient-scheduling": "Scheduling Optimization",
  "prior-authorization": "Prior Authorization Automation",
  "ai-surgical-clinical-decision-support": "OR Optimization",
  "revenue-cycle-automation": "Revenue Cycle Automation",
};

export const TECHNOLOGY_CATEGORY_ORDER = Object.keys(
  TECHNOLOGY_CATEGORY_LABELS,
).sort((a, b) =>
  (TECHNOLOGY_CATEGORY_LABELS[a] ?? "").localeCompare(
    TECHNOLOGY_CATEGORY_LABELS[b] ?? "",
  ),
);

export interface TechnologyStackListProps {
  vendorByCategory: Map<string, string> | Record<string, string>;
  onSaveVendor: (categoryId: string, rawValue: string) => void;
  onSearchVendor: (categoryId: string, query: string) => Promise<string[]>;
}

function getVendor(
  vendorByCategory: Map<string, string> | Record<string, string>,
  categoryId: string,
) {
  return vendorByCategory instanceof Map
    ? vendorByCategory.get(categoryId)
    : vendorByCategory[categoryId];
}

export function TechnologyStackList({
  vendorByCategory,
  onSaveVendor,
  onSearchVendor,
}: TechnologyStackListProps) {
  return (
    <ul>
      {TECHNOLOGY_CATEGORY_ORDER.map((categorySlug) => {
        const label = TECHNOLOGY_CATEGORY_LABELS[categorySlug] ?? categorySlug;
        const vendor = getVendor(vendorByCategory, categorySlug) ?? null;
        const displayValue = vendor ?? "None";

        return (
          <li
            key={categorySlug}
            className="flex items-center gap-3.5 py-[14px] px-1 border-b border-(--border-subtle) text-[13px] last:border-b-0"
          >
            <span className="flex-1 min-w-0 text-(--fg-secondary)">
              {label}
            </span>
            <span
              className={[
                "shrink-0 text-right",
                vendor ? "text-(--fg-primary)" : "text-(--fg-muted)",
              ].join(" ")}
            >
              <EditableAutocomplete
                value={displayValue}
                align="right"
                onSave={(value) => onSaveVendor(categorySlug, value)}
                onSearch={(query) => onSearchVendor(categorySlug, query)}
                ariaLabel={`Set vendor for ${label}`}
                allowFreeText
                allowEmpty
              />
            </span>
          </li>
        );
      })}
    </ul>
  );
}
